import { Polygon } from 'react-leaflet'
import type { LatLngExpression } from 'leaflet'
import type { PolygonGeometry, Zone } from '@/lib/api'
import { useZones } from '@/lib/api'
import { useTheme } from '@/lib/theme'

export function ServiceZoneLayer() {
  const { data: zonesData, isLoading } = useZones()
  const { resolvedTheme } = useTheme()

  if (isLoading || !zonesData?.zones) {
    return null
  }

  // Convert API coordinates [longitude, latitude] to Leaflet format [latitude, longitude]
  const convertCoordinates = (
    points: Array<Array<number>>,
  ): Array<LatLngExpression> => {
    return points.map(([lon, lat]) => [lat, lon])
  }

  // Subtle neutral styling: low opacity gray that won't conflict with blue indicators
  const zoneStyle = {
    color: resolvedTheme === 'dark' ? '#9ca3af' : '#6b7280', // gray-400 : gray-500
    fillColor: resolvedTheme === 'dark' ? '#9ca3af' : '#6b7280',
    fillOpacity: 0.08, // 8% - very subtle, won't overpower map
    weight: 1.5,
    opacity: 0.35, // Low opacity border
  }

  return (
    <>
      {zonesData.zones.map((zone: Zone) =>
        zone.geometry.polygons.map((polygon: PolygonGeometry, idx: number) => (
          <Polygon
            key={`${zone.zoneId}-${idx}`}
            positions={convertCoordinates(polygon.points)}
            pathOptions={zoneStyle}
          />
        )),
      )}
    </>
  )
}
